import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StudentClassItem from './StudentClassItem';
import instance from '../../../api/axios/utils.ts/instance';
import {
  classInfo,
  myLearningInfoType,
} from '../../../constants/types/student-type';
import { getErrorMessages } from '../../../api/utils/util-func';
import { openAlert } from '../../../store/features/modalSlice';
import { useAppDispatch } from '../../../store/hook';
import TextWinds from '../../../components/common/TextWinds';
import { MAX_CLASS_LIMIT } from '../../../components/student/profile/ClassInfoSection';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { LoadingSpinner } from '../../../components/Loading/LoadingSpinner';
import HFbutton from '../../../components/button/HFbutton';

const StudentClassList = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [classList, setClassList] = useState<myLearningInfoType[]>([]);
  const [classInfos, setClassInfos] = useState<classInfo[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const getClasses = async () => {
    setIsLoading(true);
    try {
      const result = await instance.get('/v1/student/class');
      if (result.data.statusCode === 200) {
        const data = result.data.data;
        setClassList(data.myLearningInfo);
        setClassInfos(data.student.classInfos);
      }
    } catch (e) {
      dispatch(openAlert({ message: getErrorMessages(e) }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getClasses();
  }, []);

  if (isLoading) {
    return <LoadingSpinner message="데이터 조회중" />;
  }

  return (
    <div className="m-auto grid grid-cols-1 justify-items-center gap-8 px-4 md:grid-cols-2 xl:grid-cols-3">
      {classList?.map((item) => (
        <StudentClassItem
          key={item.myLearning.id}
          data={item}
          classInfos={classInfos}
        />
      ))}

      {classList.length === 0 && (
        <div className="col-span-full">
          <TextWinds type="content_body3" color="gray7">
            등록된 클래스가 없습니다.
          </TextWinds>
        </div>
      )}

      {classList.length < MAX_CLASS_LIMIT && (
        <div className="col-span-full">
          <HFbutton
            type="primary-outlined"
            onClick={() =>
              navigate('/student/profile', {
                state: { openSection: 'class' },
              })
            }
          >
            클래스 추가하러 가기 <ArrowRightOutlined />
          </HFbutton>
        </div>
      )}
    </div>
  );
};

export default StudentClassList;
